import { observer } from 'mobx-react';

import { useStores } from '../../../stores/useStores';

import { PlayingNowBadge } from './PlayingNowBadge';
import styles from './PlayingNowSlot.module.scss';

interface PlayingNowSlotProps {
  masterCasinoGameId: number;
  identifier: string;
}

/** Own observer, so a count change re-renders this row and not the card. Empty until the store reserves the strip. */
export const PlayingNowSlot = observer(({ masterCasinoGameId, identifier }: PlayingNowSlotProps) => {
  const { playingNowStore, coinTypeStore } = useStores();

  if (!playingNowStore.stripReserved) {
    return null;
  }

  const count = playingNowStore.countFor(masterCasinoGameId, coinTypeStore.coinType);

  return (
    <div className={styles.slot} data-testid={`playing-now-slot-${identifier}`}>
      {count ? <PlayingNowBadge count={count} testId={`playing-now-badge-${identifier}`} /> : null}
    </div>
  );
});
